// 运行时平台探测：决定 UI 以「整窗小组件」还是「网页」形态呈现。
// 这里不再有 iPhone/iPad/Web 的演示切换，真实端各自适配自己的外壳。

export function isTauri() {
  return (
    typeof window !== "undefined" &&
    (!!window.__TAURI_INTERNALS__ || !!window.__TAURI__)
  );
}

export function isMobile() {
  if (typeof navigator === "undefined" || typeof window === "undefined")
    return false;
  const ua = navigator.userAgent || "";
  const touch = (navigator.maxTouchPoints || 0) > 1;
  // iPadOS 13+ 的 UA 伪装成 "Macintosh"，靠「Mac 标识 + 触屏」识别；
  // 否则 iPad 横屏（~1024px）会被当成桌面 web，走错布局。
  const iPadOS = /Macintosh/.test(ua) && touch;
  return (
    /android|iphone|ipad|ipod|mobile/i.test(ua) ||
    iPadOS ||
    (touch && window.innerWidth < 1024)
  );
}

// 'desktop'（Tauri 桌面壳，mac/win）| 'mobile'（手机/平板触屏）| 'web'（桌面浏览器）
export function getPlatform() {
  if (isTauri()) return "desktop";
  if (isMobile()) return "mobile";
  return "web";
}

// 桌面壳与手机端都铺满整窗，呈现为「小组件」。web 端则居中为手机宽度。
export function isWidget() {
  return isTauri() || isMobile();
}
